import React, {useContext} from 'react';

import api    from '../../../api';
import values from '../../../values';

import { useQuery             } from 'react-query';
import { locationNamespace    } from '../../../types/location.namespace';
import { CustomDropdownSearch } from '../../index';

import './index.sass';
import Context from "../../../context";
import utils from "../../../utils";
import Cookies from "js-cookie";

type Props = {
  isError    ?: boolean;
  errorText  ?: string;
  defaultItem : locationNamespace.province.index | undefined;
  onSelectItem: (province: locationNamespace.province.index) => void;
}

const ProvinceDropdown: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { userInfo } = useContext(Context.UserScreen);
  const userType = utils.stringHexConversion.reverse(Cookies.get(values.constants.USER.TYPE));
  const [requestProvince , setRequestProvince ] = React.useState<locationNamespace.province.request>({
    limit: 50,
  });

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getProvince = useQuery(
    [values.useQueryKeys.locationGetProvince, requestProvince],
    () => api.get.common.searchProvince(requestProvince)
  );

  const provinceFiltered4Company = getProvince?.data?.result && getProvince?.data.result.docs?.filter((item: any) =>
    userInfo?.companyInformation?.province?.includes(item?._id)
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  const dropdoneItems = userType === 'COMPANY' ? provinceFiltered4Company : getProvince?.data?.result?.docs;
  return (
    <section id='location-dropdown-search-province'>
      <span>انتخاب استان</span>
      <CustomDropdownSearch
        isSearch
        defaultItem={props.defaultItem}
        items={dropdoneItems ?? []}
        itemName={'name'} placeHolder={'انتخاب استان'}
        onSelectItem={props.onSelectItem}
      />
      {props?.isError && (<p>{props?.errorText}</p>)}
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default ProvinceDropdown;
